// Module
var code = `<mat-dialog-content>
    <div class="hoa-dialog__container">
        <div class="hoa-dialog__header">
            <h1 tid="noPropertyHeader">Unable to locate your property</h1>
        </div>
        <div class="hoa-dialog__main">
            <p tid="noPropertyParagraph1">Please confirm that the Property IDs and address you entered are correct.</p>
            <p tid="noPropertyParagraph2">If the error continues, please contact your management company.</p>
            <div class="u-mB9">
                <a [routerLink]="['/contact']"
                   [queryParams]="{pmcId: data.pmcId}"
                   (click)="closeThisDialog(0)"
                   tid="contactLink" >
                    Contact {{data.pmcName || 'Management Company'}}
                </a>
            </div>
        </div>
        <div class="hoa-dialog__footer" ifOverFlowXClass="hoa-dialog__footer--overflowX">
            <button tid="confirm" class="Button Button--blue Button--minWidth130" (click)="closeThisDialog(0)">Confirm</button>
        </div>
    </div>
</mat-dialog-content>`;
// Exports
module.exports = code;